import { useMemo } from 'react'
import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useMenuOutboundLayoutContext } from 'widgets/Menu/ui/MenuOutbound'
import { BroadcastsPageStore } from 'pages/broadcasts/store/broadcastsPageStore'
import { BroadcastPageContext } from 'pages/broadcasts/context/broadcastsPageContext'

export const BroadcastLayout = observer(() => {
  const menuLayoutStore = useMenuOutboundLayoutContext()
  const entities = useEntitiesContext()
  const pageStore = useMemo(
    () => new BroadcastsPageStore(menuLayoutStore.pageLayoutStore, entities),
    []
  )

  return (
    <BroadcastPageContext.Provider value={pageStore}>
      <Outlet />
    </BroadcastPageContext.Provider>
  )
})
